import React from 'react';
import {sanatoriumFeatures} from "../components/helpers/sanatoriumFeatures";
const FoodPage = () => {
    return (
        <div className="food-page-container">
            {/* Заголовок страницы - адаптируем */}
            <header className="page-header">
                <h1>Услуги и Инфраструктура</h1>
            </header>

            {/* Основная секция с карточками */}
            <section className="section">
                {/* Описание секции */}
                <div className="section-description">
                    <p>Исследуйте всё, что наш санаторий предлагает для вашего комфортного пребывания, оздоровления и интересного досуга.</p>
                </div>

                {/* Контейнер для грида карточек */}
                <div className="cards-grid">
                    {/* Маппинг данных о возможностях санатория в карточки */}
                    {sanatoriumFeatures.map(feature => (
                        <div className="info-card" key={feature.id}> {/* key важен для списков в React */}
                            {/* Баннер сверху */}
                            <div className={`card-banner ${feature.bannerText === 'БЕСПЛАТНО' ? 'banner-free' : 'banner-paid'}`}>
                                {feature.bannerText}
                            </div>

                            {/* Фотография */}
                            {feature.imageUrl && <img src={feature.imageUrl} alt={feature.title} className="card-image"/>}

                            {/* Основной контент карточки */}
                            <div className="card-content">
                                <h3 className="card-title">{feature.title}</h3>
                                <p className="card-description">{feature.description}</p>
                                {/* Если есть мета-информация, добавь здесь */}
                                {/* <p className="card-meta">{feature.metaInfo}</p> */}
                            </div>
                        </div>
                    ))}
                </div>

            </section>

            {/* Если нужно другие секции, добавь их здесь */}

        </div>
    );
};

export default FoodPage;